import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Section, Eyebrow } from "@/components/PublicLayout";

export default function Faculty() {
  const { t, field } = useI18n();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/faculty").then((r) => setData(r.data)); }, []);
  if (!data) return <Section className="py-24"><p className="text-ink/50">{t("loading")}</p></Section>;
  return (
    <Section className="py-16 md:py-24">
      <Eyebrow>{t("fac_eyebrow")}</Eyebrow>
      <h1 className="font-serif text-4xl md:text-6xl tracking-tight text-ink">{t("fac_h1")}</h1>
      <p className="mt-5 max-w-2xl text-ink/65 leading-relaxed">{field(data, "note")}</p>
      <div className="mt-8 flex flex-wrap gap-8">
        <div><div className="font-serif text-5xl text-heraldic">{data.total_positions}</div><div className="text-sm text-ink/50">{t("fac_positions")}</div></div>
        <div><div className="font-serif text-5xl text-heraldic">{data.faculties.length}</div><div className="text-sm text-ink/50">{t("fac_faculties")}</div></div>
        <div><div className="font-serif text-5xl text-heraldic">100%</div><div className="text-sm text-ink/50">{t("fac_doctorate")}</div></div>
      </div>

      <div className="mt-14">
        <Eyebrow>{t("fac_named")}</Eyebrow>
        <div className="grid md:grid-cols-3 gap-px bg-border border border-border mt-4">
          {data.named.map((p) => (
            <div key={p.slug} className="bg-paper p-7">
              <div className="h-20 w-20 rounded-full overflow-hidden bg-heraldic/10 border border-heraldic/20 flex items-center justify-center font-serif text-xl text-heraldic">
                {p.photo ? <img src={p.photo.startsWith("http") ? p.photo : `${process.env.REACT_APP_BACKEND_URL}${p.photo}`} alt={p.name} className="h-full w-full object-cover" /> : p.name.split(" ").filter(Boolean).slice(-2).map((n) => n[0]).join("")}
              </div>
              <div className="mt-3 font-serif text-xl text-ink">{p.name}</div>
              <div className="text-sm text-heraldic">{p.role}</div>
              {p.bio && <p className="mt-2 text-sm text-ink/60 leading-relaxed">{p.bio}</p>}
              {(p.teaching_areas || []).length > 0 && <div className="mt-2 text-xs text-ink/50">{(p.teaching_areas || []).join(" · ")}</div>}
            </div>
          ))}
        </div>
      </div>

      <div className="mt-14">
        <Eyebrow>{t("fac_depts")}</Eyebrow>
        <div className="grid md:grid-cols-2 gap-px bg-border border border-border mt-4">
          {data.faculties.map((f) => (
            <div key={f.name} className="bg-paper p-7 flex items-center justify-between">
              <div>
                <div className="font-serif text-lg text-ink">{f.name}</div>
                <div className="text-xs text-ink/50 mt-1">{field(f, "standard")}</div>
              </div>
              <div className="font-mono text-2xl text-heraldic">{f.professors}</div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
